<ng-template #cpuInput >
  @if (value !== null && value !== undefined) {
    <p>{{value}}</p>
  }
  @if (value === null || value === undefined) {
    <p>{{formGroup.controls[formName].value}}</p>
  }
</ng-template>

<app-base [componentsTemplate]="cpuInput" [childContext]="ctx" ></app-base>
